{
  "scheduling": "預約排期",
  "date": "日期",
  "time": "時間",
  "duration": "時長",
  "provider": "醫生",
  "reason": "求診原因",
  "status": "狀態",
  "statusOptions": {
    "scheduled": "已預約",
    "confirmed": "已確認",
    "arrived": "已到達",
    "checked-in": "已報到",
    "in-progress": "進行中",
    "completed": "已完成",
    "cancelled": "已取消",
    "no-show": "未到診"
  },
  "coverageScope": {
    "panel": "病人組別",
    "unit": "病房",
    "facility": "整個機構"
  },
  "coverageScopeDescription": {
    "panel": "僅限被代診醫生的病人組別。",
    "unit": "被代診醫生所屬的病房。",
    "facility": "整個機構 — 通常為當值安排。"
  },
  "dayShort": {
    "0": "日",
    "1": "一",
    "2": "二",
    "3": "三",
    "4": "四",
    "5": "五",
    "6": "六"
  },
  "blockType": {
    "available": "可預約",
    "blocked": "已封鎖"
  },
  "appointmentTypes": {
    "followUp": "覆診",
    "newPatient": "新症",
    "consultation": "諮詢",
    "procedure": "處置",
    "urgent": "緊急",
    "wellnessCheck": "健康檢查",
    "physical": "身體檢查",
    "telemedicine": "遙距醫療",
    "scheduleTemplate": "排期範本"
  },
  "pages": {
    "providerDirectory": {
      "title": "醫生目錄",
      "subtitle": "瀏覽及搜尋醫療人員",
      "search": {
        "namePlaceholder": "按姓名搜尋...",
        "specialtyPlaceholder": "按專科搜尋..."
      },
      "filters": {
        "facilityAriaLabel": "按機構篩選",
        "departmentAriaLabel": "按科室篩選",
        "allFacilities": "所有機構",
        "allDepartments": "所有科室"
      },
      "loading": "正在載入醫生資料...",
      "loadError": "無法載入醫生目錄。",
      "empty": "找不到符合條件的醫生。",
      "npiLabel": "NPI:"
    },
    "scheduleTemplateForm": {
      "title": "建立排班範本",
      "labels": {
        "provider": "醫生",
        "dayOfWeek": "星期",
        "startTime": "開始時間",
        "endTime": "結束時間",
        "slotDuration": "時段長度(分鐘)",
        "templateName": "範本名稱",
        "effectiveStartDate": "生效日期"
      },
      "slotDurationOption": "{{minutes}} 分鐘",
      "buttons": {
        "cancel": "取消",
        "save": "儲存範本"
      },
      "toast": {
        "success": "已儲存排班範本",
        "failure": "儲存排班範本失敗"
      },
      "placeholders": {
        "templateName": "例如 星期一上午門診"
      },
      "defaultName": "{{day}} 排班"
    },
    "scheduleManagement": {
      "title": "排班管理",
      "backToDashboard": "← 儀表板",
      "newTemplate": "新增範本",
      "today": "今天",
      "blockTooltip": "{{start}} - {{end}} ({{state}})",
      "slotsLabel": "{{minutes}} 分鐘時段",
      "legend": {
        "booked": "已預約"
      },
      "upcomingAppointmentsHeading": "即將到來的預約 - {{providerName}}",
      "loadingAppointments": "正在載入預約...",
      "unknownPatient": "未知病人",
      "fallbackAppointmentType": "一般",
      "noUpcomingAppointments": "此醫生暫無即將到來的預約"
    },
    "providerCoverage": {
      "title": "醫生代診",
      "subtitle": "限時代診 — 在指定時段內將您的病人組別交予同事。有別於緊急臨時存取;用於休假、當值輪替及預定缺勤。",
      "actions": {
        "newCoverage": "新增代診",
        "cancel": "取消"
      },
      "form": {
        "title": "新增代診安排",
        "labels": {
          "coveredProviderId": "被代診醫生",
          "coveringProviderId": "代診醫生",
          "scope": "範圍",
          "from": "起始",
          "until": "截止",
          "reason": "原因"
        },
        "placeholders": {
          "coveredProviderId": "其病人組別被代診的醫生",
          "coveringProviderId": "於該時段接手的醫生",
          "reason": "例如:4 月 22–29 日年假;週末當值代診"
        },
        "help": {
          "coveredProviderId": "未獲 COVERAGE_ADMIN 權限時，必須為閣下本人。",
          "coveringProviderId": "按姓名搜尋並選擇 — 絕不會將代診授予手動輸入的 ID。"
        },
        "aria": {
          "effectiveFromDate": "生效起始日期",
          "effectiveFromTime": "生效起始時間",
          "effectiveUntilDate": "生效截止日期",
          "effectiveUntilTime": "生效截止時間"
        },
        "buttons": {
          "cancel": "取消",
          "create": "建立代診"
        },
        "typeaheadEmpty": "找不到醫生"
      },
      "sections": {
        "mine": {
          "title": "我的代診",
          "subtitle": "我作為代診或被代診醫生的所有紀錄。",
          "empty": "暫無代診紀錄。"
        },
        "all": {
          "title": "全部代診",
          "subtitle": "機構內所有代診安排。管理員檢視。",
          "empty": "未有任何代診。可能是好消息,或篩選條件已過時。"
        }
      },
      "list": {
        "coveringConnector": "代診",
        "groups": {
          "active": "進行中 ({{count}})",
          "planned": "計劃 / 過往 ({{count}})",
          "revoked": "已撤銷 ({{count}})"
        },
        "untilRevoked": "直至撤銷",
        "revokedPrefix": "已撤銷",
        "revokeTitle": "撤銷"
      },
      "revokeDialog": {
        "title": "撤銷代診?",
        "description": "{{coveringProviderName}}將不再代診{{coveredProviderName}}。紀錄將保留於審核日誌中。",
        "confirm": "撤銷",
        "reasonPlaceholder": "此次代班提前結束的原因（選填）"
      },
      "toast": {
        "created": "已建立代診",
        "revoked": "已撤銷代診",
        "invalid": "代診無效 — 請檢查醫生及日期",
        "forbidden": "未獲准為此醫生建立代診",
        "createFailed": "無法建立代診",
        "revokeFailed": "無法撤銷代診"
      }
    },
    "appointments": {
      "title": "預約",
      "subtitle": "安排及管理病人預約",
      "actions": {
        "refresh": "重新整理",
        "schedule": "安排預約",
        "arriveTitle": "記錄到達",
        "arriveAria": "記錄 {{patientName}} 的到達",
        "checkInTitle": "報到",
        "checkInAria": "為 {{patientName}} 報到",
        "rescheduleTitle": "改期",
        "rescheduleAria": "為 {{patientName}} 改期",
        "cancelTitle": "取消",
        "cancelAria": "取消 {{patientName}} 的預約",
        "checkedInLabel": "已報到",
        "startVisitTitle": "開始診症",
        "startVisitAria": "開始 {{patientName}} 的診症"
      },
      "weekNav": {
        "previous": "上一週",
        "previousAria": "上一週",
        "next": "下一週",
        "nextAria": "下一週"
      },
      "calendar": {
        "gridAria": "每週預約日曆",
        "timeColumn": "時間",
        "loading": "正在載入排期...",
        "cellAria": "{{dayLabel}} {{date}} {{time}}",
        "cellTitle": "{{patientName}} - {{appointmentType}} ({{status}})"
      },
      "upcoming": {
        "heading": "即將到來的預約",
        "empty": "本週沒有預約",
        "durationMinutes": "{{minutes}} 分鐘",
        "columns": {
          "dateTime": "日期 / 時間",
          "patient": "病人",
          "type": "類型",
          "provider": "醫生",
          "duration": "時長",
          "status": "狀態",
          "actions": "操作"
        }
      },
      "toast": {
        "cancelled": "預約已取消",
        "cancelFailed": "取消預約失敗",
        "visitStarted": "已開始診症",
        "startVisitFailed": "無法開始診症",
        "arrivalRecorded": "已記錄到達",
        "arrivalFailed": "無法記錄到達"
      }
    },
    "appointmentForm": {
      "title": {
        "create": "新增預約",
        "edit": "重新安排預約"
      },
      "labels": {
        "patient": "病人",
        "appointmentType": "預約類型",
        "provider": "醫生",
        "scheduledAt": "預約時間",
        "duration": "時長",
        "reason": "就診原因"
      },
      "placeholders": {
        "patientSearch": "依姓名或病歷編號搜尋病人...",
        "provider": "醫生姓名",
        "reason": "簡要就診原因..."
      },
      "patientTypeahead": {
        "empty": "找不到病人"
      },
      "aria": {
        "appointmentDate": "預約日期",
        "appointmentTime": "預約時間"
      },
      "durationOption": "{{minutes}} 分鐘",
      "buttons": {
        "cancel": "取消",
        "schedule": "安排預約",
        "update": "更新預約"
      },
      "toast": {
        "created": "預約建立成功",
        "updated": "預約已更新",
        "createFailed": "建立預約失敗",
        "updateFailed": "更新預約失敗"
      },
      "validation": {
        "patientRequired": "請選擇一位病人",
        "appointmentTypeRequired": "預約類型為必填項",
        "scheduledAtRequired": "請填寫日期和時間",
        "durationInvalid": "時長必須介乎 1 至 480 分鐘",
        "providerRequired": "請選擇一位醫生"
      },
      "providerTypeahead": {
        "empty": "找不到醫生"
      },
      "loadingEdit": "正在載入預約…",
      "loadEditError": "無法載入此預約。",
      "patientLocked": "更改預約時不能更換病人。"
    },
    "waitlist": {
      "title": "預約候補名單",
      "backToDashboard": "← 儀表板",
      "entryCount": "{{count}} 項記錄",
      "searchPlaceholder": "搜尋患者姓名、病歷號或備註...",
      "clearSearchAria": "清除搜尋",
      "filters": {
        "allProviders": "所有醫生",
        "allTypes": "所有類型",
        "providerAriaLabel": "按醫生篩選",
        "typeAriaLabel": "按預約類型篩選"
      },
      "columns": {
        "patient": "患者",
        "provider": "醫生",
        "type": "類型",
        "priority": "優先次序",
        "requestedDates": "申請日期",
        "dateAdded": "新增日期",
        "notes": "備註",
        "actions": "操作",
        "reason": "就診原因"
      },
      "priority": {
        "urgent": "緊急",
        "routine": "常規",
        "flexible": "彈性"
      },
      "actions": {
        "scheduleTitle": "安排預約",
        "editPriorityTitle": "編輯優先次序",
        "removeTitle": "從候補名單移除"
      },
      "empty": "沒有符合篩選條件的候補記錄",
      "loadFailed": "無法載入候補名單。請檢查連線後重試。",
      "modal": {
        "title": "安排預約",
        "closeAria": "關閉",
        "providerLabel": "醫生：",
        "requestedLabel": "申請：",
        "dateTimeLabel": "預約日期及時間 *",
        "dateAria": "預約日期",
        "timeAria": "預約時間",
        "requestedWindow": "申請時段：{{start}} — {{end}}",
        "cancel": "取消",
        "submit": "安排"
      },
      "toasts": {
        "removed": "已從候補名單移除",
        "priorityUpdated": "優先次序已更新",
        "scheduled": "已安排預約並從候補名單移除",
        "dateTimeRequired": "請選擇日期和時間",
        "updateFailed": "更新候補名單失敗",
        "promoteOrphaned": "預約已建立，但候補記錄未能更新。重試前請先查看排期。"
      }
    },
    "checkIn": {
      "title": "病人登記",
      "subtitle": "登記 — 保險、授權及自付額。病人已到達。",
      "fields": {
        "insuranceId": "保險",
        "copayAmount": "自付額",
        "copayCollected": "已收取自付額",
        "authorizationNumber": "授權編號",
        "authorizationVerified": "授權已核實"
      },
      "copayHint": "標記已收取自付額將在病人帳戶中記錄一筆付款。",
      "submit": "完成登記",
      "cancel": "取消",
      "toast": {
        "success": "病人已登記",
        "failed": "無法登記病人"
      }
    },
    "providerTypeahead": {
      "loadError": "醫生名錄無法使用 — 請檢查網絡連線並重試。",
      "retry": "重試"
    }
  }
}
